export const isBranchOpen = (branch) => {
  if (!branch) return { isOpen: true, nextOpen: '' }; 
  if (!branch.openingTime || !branch.closingTime) return { isOpen: true, nextOpen: '' };

  const now = new Date();
  
  // Create a formatter for 'Asia/Aden'
  // Use en-GB to guarantee HH:mm format (24 hour)
  try {
    const options = { timeZone: 'Asia/Aden', hour: '2-digit', minute: '2-digit', hour12: false };
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    const timeString = formatter.format(now); // "HH:mm"

    const [currentH, currentM] = timeString.split(':').map(Number);
    const currentTime = currentH * 60 + currentM;

    const [openH, openM] = branch.openingTime.split(':').map(Number);
    const openTime = openH * 60 + openM;

    const [closeH, closeM] = branch.closingTime.split(':').map(Number);
    const closeTime = closeH * 60 + closeM;

    let isOpen = false;

    if (closeTime > openTime) {
      // Normal day (e.g. 09:00 - 23:00)
      isOpen = currentTime >= openTime && currentTime < closeTime;
    } else {
      // Spans midnight.
      // Open if time >= open OR time < close
      isOpen = currentTime >= openTime || currentTime < closeTime;
    }
    
    return {
      isOpen,
      nextOpen: formatTime(branch.openingTime),
      rawOpeningTime: branch.openingTime
    };
  } catch (e) {
    console.error("Error calculating branch open time", e);
    return { isOpen: true, nextOpen: '' };
  }
};

const formatTime = (time) => {
   if(!time) return '';
   const [h, m] = time.split(':');
   const H = parseInt(h);
   const ampm = H >= 12 ? 'PM' : 'AM';
   const hour12 = H % 12 || 12;
   return `${hour12}:${m} ${ampm}`;
}
